import BasicContentIconCards from './BasicContentIconCards';

export { type BasicContentIconCardsProps } from './BasicContentIconCards';
export default BasicContentIconCards;
